import { LangFa } from "./fa/Lang";
// import { LangEn } from "./en/Lang";

export const Lang = {
    ...LangFa
}